module.exports = __webpack_public_path__ + "static/media/close-icon.ec5fed39.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close-icon.svg
// module id = 50
// module chunks = 0